import { checkWithDefaultValue, genRefId } from './index'
import {
  onCheckCondition,
  searchCondition,
} from 'designer/component/action/condition/Action'
import objectPath from 'object-path'

export const updateJsonTable = (newData, dataUpdate, propAction) => {
  let {
    designContext,
    uischema,
    updateData = () => {},
    stateParent,
  } = propAction
  const {
    render: [render, setRender],
  } = stateParent

  let { jsonForm } = designContext
  let formData = jsonForm.formData
  let tableKey = uischema.key
  let hasEditRowCondition = searchCondition(jsonForm, tableKey, {
    stateKey: 'isEditRow',
  })
  let hasAfterEditRowCondition = searchCondition(jsonForm, tableKey, {
    stateKey: 'isAfterEditRow',
  })
  if (hasEditRowCondition.length > 0) {
    onCheckCondition(designContext, formData, tableKey, {
      dataTable: dataUpdate,
      rowData: [newData],
      isEditRow: true,
      filterCondition: hasEditRowCondition,
    })
  } else if (hasAfterEditRowCondition.length > 0) {
    updateData(dataUpdate)
    onCheckCondition(designContext, formData, tableKey, {
      isEditRow: true,
      filterCondition: hasAfterEditRowCondition,
    })
  } else {
    updateData(dataUpdate)
  }
  setRender(true)
}

export const updateSyncTable = (newData, dataUpdate, propAction) => {
  let {
    designContext,
    updateSyncData = () => {},
    syncKey,
    syncName,
  } = propAction
  let { jsonForm } = designContext
  let formData = jsonForm.formData

  let hasEditRowCondition = searchCondition(jsonForm, syncKey, {
    stateKey: 'isEditRow',
  })
  let hasAfterEditRowCondition = searchCondition(jsonForm, syncKey, {
    stateKey: 'isAfterEditRow',
  })
  if (hasEditRowCondition.length > 0) {
    onCheckCondition(designContext, formData, syncKey, {
      dataTable: dataUpdate,
      rowData: [newData],
      isEditRow: true,
      filterCondition: hasEditRowCondition,
    })
  } else if (hasAfterEditRowCondition.length > 0) {
    updateSyncData(syncKey, syncName, dataUpdate)
    onCheckCondition(designContext, formData, syncKey, {
      isEditRow: true,
      filterCondition: hasAfterEditRowCondition,
    })
  } else {
    updateSyncData(syncKey, syncName, dataUpdate)
  }
}

export const onRowTableUpdate = (newData, oldData, propAction) => {
  let {
    designContext,
    uischema,
    stateParent,
    isLoadSYNC,
    syncKey,
    config,
    updateData,
    formComponentName,
  } = propAction
  let { isFavoriteModal, jsonData = [], favoriteDataKey } = config
  let { jsonForm, isUiChanged } = designContext
  let formData = jsonForm.formData
  let editFavorite = isUiChanged?.editFavorite
  let favoriteJson = objectPath.get(editFavorite, `jsonData.${favoriteDataKey}`)

  const {
    loading: [, setLoading],
  } = stateParent
  const columnRefId = objectPath.get(uischema, 'loadData.columnRefId')

  setLoading(true)
  let index = -1
  let tableKey = isLoadSYNC ? syncKey : uischema.key
  let tableName = uischema.name
  tableKey = formComponentName ? `${formComponentName}.${tableKey}` : tableKey
  tableName = formComponentName
    ? `${formComponentName}.${tableName}`
    : tableName
  let arrayTable = objectPath.get(isUiChanged, `arrayTable.${tableKey}`)
  arrayTable = Array.isArray(arrayTable) ? arrayTable : []
  let formTable =
    objectPath.get(formData, tableName) ||
    objectPath.get(formData, tableKey) ||
    objectPath.get(formData, uischema.name) ||
    objectPath.get(formData, uischema.key) ||
    []
  formTable = Array.isArray(formTable) ? formTable : []
  let dataUpdate = isFavoriteModal
    ? favoriteJson || jsonData
    : arrayTable.length > 0
    ? arrayTable
    : formTable

  let rowId = objectPath.get(oldData, columnRefId)
  newData = checkWithDefaultValue(newData, uischema)

  if (objectPath.has(oldData, genRefId)) {
    let id = objectPath.get(oldData, genRefId)
    index = dataUpdate.findIndex((data) => {
      return objectPath.get(data, genRefId) === id
    })
  } else if (columnRefId && rowId) {
    index = dataUpdate.findIndex((data) => {
      return objectPath.get(data, columnRefId) === rowId
    })
  } else {
    index = dataUpdate.findIndex((data) => {
      let foundUnique = Object.keys(data).find((key) => {
        if (key === 'tableData') return false
        return objectPath.get(data, key) !== objectPath.get(oldData, key)
      })
      if (foundUnique) return false
      return true
    })
    objectPath.del(newData, 'tableData')
  }
  if (index > -1) {
    objectPath.set(dataUpdate, index, newData)
  }
  if (isFavoriteModal) {
    updateData(dataUpdate)
  } else if (isLoadSYNC) {
    updateSyncTable(newData, dataUpdate, propAction)
  } else {
    updateJsonTable(newData, dataUpdate, propAction)
  }
  setLoading(false)
  return Promise.resolve()
}
